const types = {
  GET_TEAMMATES_REQ: "GET_TEAMMATES_REQ",
  GET_TEAMMATES_RESPONSE: "GET_TEAMMATES_RESPONSE",
  GET_TEAMMATES_RESPONSE_CLEAR: "GET_TEAMMATES_RESPONSE_CLEAR",

  GET_REA_LIST_REPORT_REQ: "GET_REA_LIST_REPORT_REQ",
  GET_REA_LIST_REPORT_RESPONSE: "GET_REA_LIST_REPORT_RESPONSE",
  GET_REA_LIST_REPORT_RESPONSE_CLEAR: "GET_REA_LIST_REPORT_RESPONSE_CLEAR",

  GET_COURSE_LIST_REPORT_REQ: "GET_COURSE_LIST_REPORT_REQ",
  GET_COURSE_LIST_REPORT_RESPONSE: "GET_COURSE_LIST_REPORT_RESPONSE",
  GET_COURSE_LIST_REPORT_RESPONSE_CLEAR: "GET_COURSE_LIST_REPORT_RESPONSE_CLEAR",

  GET_MANAGER_LIST_REPORT_REQ: "GET_MANAGER_LIST_REPORT_REQ",
  GET_MANAGER_LIST_REPORT_RESPONSE: "GET_MANAGER_LIST_REPORT_RESPONSE",
  GET_MANAGER_LIST_REPORT_RESPONSE_CLEAR: "GET_MANAGER_LIST_REPORT_RESPONSE_CLEAR",

  GET_PROVIDER_LIST_REPORT_REQ: "GET_PROVIDER_LIST_REPORT_REQ",
  GET_PROVIDER_LIST_REPORT_RESPONSE: "GET_PROVIDER_LIST_REPORT_RESPONSE",
  GET_PROVIDER_LIST_REPORT_RESPONSE_CLEAR: "GET_PROVIDER_LIST_REPORT_RESPONSE_CLEAR",

  GET_BROKERAGE_FILTER_LIST_REQ: "GET_BROKERAGE_FILTER_LIST_REQ",
  GET_BROKERAGE_FILTER_LIST_REQ_RESPONSE: "GET_BROKERAGE_FILTER_LIST_REQ",
  GET_BROKERAGE_FILTER_LIST_REQ_CLEAR: "GET_BROKERAGE_FILTER_LIST_REQ_CLEAR",

  CURRENT_VIEW: "CURRENT_VIEW",

  JOY_RIDE: "JOY_RIDE",
  SHOW_DROPDOWN: "SHOW_DROPDOWN",
  SHOW_MORE_MENU: "SHOW_MORE_MENU",

  ASSIGN_TEAMMATES_REQ: "ASSIGN_TEAMMATES_REQ",
  ASSIGN_TEAMMATES_RESPONSE: "ASSIGN_TEAMMATES_RESPONSE",
  ASSIGN_TEAMMATES_RESPONSE_CLEAR: "ASSIGN_TEAMMATES_RESPONSE_CLEAR",

  SEARCH_OFFICE_LIST_REQ: "SEARCH_OFFICE_LIST_REQ",
  SEARCH_OFFICE_LIST_RESPONSE: "SEARCH_OFFICE_LIST_RESPONSE",
  SEARCH_OFFICE_LIST_RESPONSE_CLEAR: "SEARCH_OFFICE_LIST_RESPONSE_CLEAR",

  COMPLETED_COURSE_LIST_REQ: "COMPLETED_COURSE_LIST_REQ",
  COMPLETED_COURSE_LIST_RESPONSE: "COMPLETED_COURSE_LIST_RESPONSE",
  COMPLETED_COURSE_LIST_RESPONSE_CLEAR: "COMPLETED_COURSE_LIST_RESPONSE_CLEAR",

  GET_USERS_BY_OFFICE_LIST: "GET_USERS_BY_OFFICE_LIST",
  GET_USERS_BY_OFFICE_LIST_RESPONSE: "GET_USERS_BY_OFFICE_LIST_RESPONSE",
  GET_USERS_BY_OFFICE_LIST_CLEAR: "GET_USERS_BY_OFFICE_LIST_CLEAR",


  GET_TEAMS_LIST_REQ: "GET_TEAMS_LIST_REQ",
  GET_TEAMS_LIST_RES: "GET_TEAMS_LIST_RES",
  GET_TEAMS_LIST_RES_CLEAR: "GET_TEAMS_LIST_RES_CLEAR",

  ASSIGN_TO_TEAMS_REQ: "ASSIGN_TO_TEAMS_REQ",
  ASSIGN_TO_TEAMS_RES: "ASSIGN_TO_TEAMS_RES",
  ASSIGN_TO_TEAMS_RES_CLEAR: "ASSIGN_TO_TEAMS_RES_CLEAR",

  GET_ASSIGN_USERS: "GET_ASSIGN_USERS",
  GET_ASSIGN_USERS_RES: "GET_ASSIGN_USERS_RES",
  GET_ASSIGN_USERS_RES_CLEAR: "GET_ASSIGN_USERS_RES_CLEAR",

  //LP Filter
  CHOOSE_LP_REPORT_FILTER: "CHOOSE_LP_REPORT_FILTER",
  CHOOSE_LP_REPORT_FILTER_RES: "CHOOSE_LP_REPORT_FILTER_RES",
  CHOOSE_LP_REPORT_FILTER_CLEAR: "CHOOSE_LP_REPORT_FILTER_CLEAR",
  //LP Filter
  GET_ASSIGN_USER_LIST: "GET_ASSIGN_USER_LIST",
  GET_ASSIGN_USER_LIST_RES: "GET_ASSIGN_USER_LIST_RES",
  GET_ASSIGN_USER_LIST_CLEAR: "GET_ASSIGN_USER_LIST_CLEAR",

  CHANGE_DUE_DATE_ASSIGN_USER_LIST: "CHANGE_DUE_DATE_ASSIGN_USER_LIST",
  CHANGE_DUE_DATE_ASSIGN_USER_LIST_RES: "CHANGE_DUE_DATE_ASSIGN_USER_LIST_RES",
  CHANGE_DUE_DATE_ASSIGN_USER_LIST_CLEAR: "CHANGE_DUE_DATE_ASSIGN_USER_LIST_CLEAR",

  AVAILABLE_LP_BY_ENTITY_ID: "AVAILABLE_LP_BY_ENTITY_ID",
  AVAILABLE_LP_BY_ENTITY_ID_RES: "AVAILABLE_LP_BY_ENTITY_ID_RES",
  AVAILABLE_LP_BY_ENTITY_ID_CLEAR: "AVAILABLE_LP_BY_ENTITY_ID_CLEAR",

  GET_CATEGORY_BY_ENTITY_ID: "GET_CATEGORY_BY_ENTITY_ID",
  GET_CATEGORY_BY_ENTITY_ID_RES: "GET_CATEGORY_BY_ENTITY_ID_RES",
  GET_CATEGORY_BY_ENTITY_ID_CLEAR: "GET_CATEGORY_BY_ENTITY_ID_CLEAR",

  GET_CLASS: "GET_CLASS",

  GET_SURVEY_LIST_REPORT_REQ: "GET_SURVEY_LIST_REPORT_REQ",
  GET_SURVEY_LIST_REPORT_REQ_RESPONSE: "GET_SURVEY_LIST_REPORT_REQ_RESPONSE",
  GET_SURVEY_LIST_REPORT_REQ_RESPONSE_CLEAR: "GET_SURVEY_LIST_REPORT_REQ_RESPONSE_CLEAR",

  //LP Filter
  CHOOSE_LP_SURVEY_REPORT_FILTER: "CHOOSE_LP_SURVEY_REPORT_FILTER",
  CHOOSE_LP_SURVEY_REPORT_FILTER_RES: "CHOOSE_LP_SURVEY_REPORT_FILTER_RES",
  CHOOSE_LP_SURVEY_REPORT_FILTER_RES_CLEAR: "CHOOSE_LP_SURVEY_REPORT_FILTER_RES_CLEAR",
};

export default types;
